/* =========================
   Cart quantity stepper for Impact (cart-only file)
   - adds +/- buttons around input.quantity-input[is="quantity-input"]
   - triggers input/change so theme updates line item
   - MOBILE ONLY
   ========================= */
(() => {
  const isMobile = () =>
    window.matchMedia("(max-width: 749px)").matches ||
    window.matchMedia("(hover: none) and (pointer: coarse)").matches;

  const SELECTOR = 'input.quantity-input[is="quantity-input"]';

  const enhance = (root = document) => {
    if (!isMobile()) return;

    root.querySelectorAll(SELECTOR).forEach((input) => {
      if (input.closest(".qty-stepper")) return;

      const wrap = document.createElement("div");
      wrap.className = "qty-stepper";

      const btnMinus = document.createElement("button");
      btnMinus.type = "button";
      btnMinus.className = "qty-stepper__btn";
      btnMinus.setAttribute("data-qty-minus", "1");
      btnMinus.setAttribute("aria-label", "数量を減らす");
      btnMinus.textContent = "−";

      const btnPlus = document.createElement("button");
      btnPlus.type = "button";
      btnPlus.className = "qty-stepper__btn";
      btnPlus.setAttribute("data-qty-plus", "1");
      btnPlus.setAttribute("aria-label", "数量を増やす");
      btnPlus.textContent = "＋";

      const parent = input.parentNode;
      parent.insertBefore(wrap, input);
      wrap.appendChild(btnMinus);
      wrap.appendChild(input);
      wrap.appendChild(btnPlus);
    });
  };

  const bump = (input, delta) => {
    const step = Number(input.step || 1);
    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;

    let next = Number(input.value || min);
    next = next + delta * step;
    next = Math.max(min, Math.min(max, next));

    input.value = String(next);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  };

  document.addEventListener("click", (e) => {
    const minus = e.target.closest("[data-qty-minus]");
    const plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;

    const wrap = e.target.closest(".qty-stepper");
    const input = wrap?.querySelector(SELECTOR);
    if (!input) return;

    bump(input, minus ? -1 : 1);
  });

  const run = () => enhance();

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  const mo = new MutationObserver(run);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
